/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import {FC} from 'react'
import {Routes, Route, BrowserRouter, Navigate} from 'react-router-dom'
import {PrivateRoutes} from './PrivateRoutes'
import {ErrorsPage} from '../modules/errors/ErrorsPage'
import {Logout, AuthPage, useAuth} from '../modules/auth'
import {App} from '../App'

/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const {PUBLIC_URL} = process.env

const AppRoutes: FC = () => {
  const { currentUser, menu } = useAuth()

  // menu 배열이 존재하고 항목이 하나 이상이면 첫 번째 메뉴의 menuUrl을 사용하고,
  // 만약 menuUrl이 "/"로 시작하면 이를 제거합니다.
  const firstMenuUrl =
    menu && menu.length > 0
      ? menu[0].menuUrl.replace(/^\/+/, '')
      : 'dashboard'

  return (
    <BrowserRouter basename={PUBLIC_URL}>
      <Routes>
        <Route element={<App />}>
          <Route path='error/*' element={<ErrorsPage />} />
          <Route path='logout' element={<Logout />} />
          {currentUser ? (
            <>
              <Route path='/*' element={<PrivateRoutes />} />
              <Route index element={<Navigate to={firstMenuUrl} />} />
            </>
          ) : (
            <>
              <Route path='auth/*' element={<AuthPage />} />
              <Route path='*' element={<Navigate to='/auth' />} />
            </>
          )}

            {/*<>*/}
            {/*  <Route path='/*' element={<PrivateRoutes />} />*/}
            {/*  <Route index element={<Navigate to='/dashboard' />} />*/}
            {/*</>*/}
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export {AppRoutes}
